import GetApi from '../../../common/api/get'

export function setState(params) {
  return {
    type: 'SET_STATE_ROOM_TYPES',
    params: params
  }
}

export function get() {
  return async (dispatch, getState) => {
    const getApi = new GetApi()
    await getApi.execute(routeUrlHelper.classificationsRoomTypesPath(), '').then((res) => {
      dispatch(setState({ room_types: res.body.options }))
      return true
    }, (res) => {
      dispatch(setState({ error: { main: 'An error occurred' } }))
      return false
    })
  }
}
